import angular from 'angular'

import creatLoanRequestModule from './createLoanRequest/createLoanRequest'
import loanRequestsComponent from './loanRequests.component'

export default angular.module('app.pages.admin.adminDashboard.loanRequests', [creatLoanRequestModule.name])
  .directive('adminLoanRequests', loanRequestsComponent)
